export const RO = {
  preparing_zip: "Se pregătește zip-ul…",
  compressing: "Se comprimă…",
  info_icon: "Odată marcat ca finalizat, nu se mai pot alătura sau adăuga membri suplimentari, iar toate grupurile de chat vor fi dezactivate. Vă rugăm să rețineți că proiectul, împreună cu toate grupurile de chat și datele, va rămâne accesibil într-o stare dezactivată.",
  mark_is_done: "Sunteți sigur că doriți să marcați proiectul ca finalizat? Odată marcat, nu se mai pot alătura sau adăuga membri suplimentari, iar toate grupurile de chat vor fi dezactivate. Vă rugăm să rețineți că proiectul, împreună cu toate grupurile de chat și datele, va rămâne accesibil într-o stare dezactivată.",
  mark_not_done: "Sunteți sigur că doriți să redeschideți proiectul? Odată marcat ca deschis, membri suplimentari se pot alătura sau pot fi adăugați, iar toate grupurile de chat vor fi reactivate.",
  mark_as_completed: "Marchează proiectul ca finalizat",
  room_completed: "Proiect finalizat",
  room_members: "Membrii proiectului",
  deactivated_rooms: "Proiecte dezactivate",
  deactivated_chats: "Chat-uri dezactivate",
  completed_rooms: "Proiecte finalizate",
  request_to_join_a_room: 'Cerere de alăturare la proiect',
  wants_to_rejoin_room: 'Username dorește să se alăture din nou proiectului Roomname.',
  invited_you_to_join_room: 'Username te-a invitat să te alături proiectului Roomname.',
  restart: "Repornire",
  update_text: "O nouă actualizare este disponibilă. Faceți clic pe repornire pentru a instala actualizarea.",
  update_availble: "Actualizare disponibilă",
  Loading: "Se încarcă...",
  logout: "Deconectare",
  back: 'Înapoi',
  company_list: "Lista companiilor",
  followers: "Urmăritori",
  followings: "Urmăriți",
  article: "Articol",
  companies: "Companii",
  one_to_one_chat: " Chat unu la unu",
  profile: "Profil",
  company: "Companie",
  company_selection: "Selectarea companiei",
  home: "Acasă",
  contact: "Contact ",
  add_company: "Adaugă companie ",
  add_project: "Adaugă proiect ",
  capacities: "Capacități ",
  work_area: "Zonă de lucru",
  company_services: "Servicii companie",
  website: "Site web",
  search_contacts: "Caută contacte",
  add_or_join_a_company: "Adaugă sau alătură-te unei companii",
  follow: "Urmărește",
  following: "Urmărește",
  like: "Apreciază",
  company_contacts: "Contact companie",
  leave_the_company: "Părăsește compania",
  news: "Știri",
  earlier: "Anterior",
  action: "Acțiune",
  another_action: "Altă acțiune",
  something_else: "Altceva",
  search: "Căutare",
  search_rooms: "Caută proiecte",
  search_articles: "Caută articole",
  contacts: "Contacte",
  suggestions: "Sugestii",
  project_list: "Lista proiectelor",
  search_results: "Rezultate căutare",
  add_or_join_project: "Adaugă sau alătură-te la proiect",
  details: "Detalii",
  your_position_within_company:
    "Vă rugăm să alegeți poziția dvs. în cadrul companiei.",
  close_modal: "Închide",
  map: "Hartă",
  or: "Sau",
  name: "Nume*",
  street: "Stradă*",
  house_number: "Număr casă",
  postal_code: "Cod poștal",
  city: "Oraș*",
  opened_by: "Deschis de:",
  project_No: "Număr proiect: ",
  building_type: "Tip clădire*",
  building_types: "Tip clădire",
  add_join: "Adaugă/Alătură-te",
  mandatory_fiels: "*câmpuri obligatorii",
  invalid_fiels: "Acest câmp este obligatoriu",
  add_or_join_company: "Adaugă sau alătură-te companiei",
  name_of_the_company: "Numele companiei",
  edit_company_details: "Editează detaliile companiei",
  branch_of_the_building_industry: "Ramura industriei construcțiilor",
  corporate_form: "Formă juridică",
  position_within_company: "Poziție în cadrul companiei",
  request_confirmation: "Cereri de proiect în așteptare",
  company_e_mail: "E-mail companie",
  type_of_filter: "Tastați pentru filtrare...",
  setting: "Setare",
  dashboard: "Tablou de bord",
  settings: "Setări",
  views: "Vizualizări",
  times_seen: "ori văzut",
  see_more: "...mai mult",
  see_less: "...mai puțin",
  in_search: "în căutare",
  reset_password: "Resetează parola",
  submit: "Trimite",
  password: "Parolă",
  email: "E-mail",
  confirm_password: "Confirmă parola",
  reset_email: "Resetează e-mail",
  update: "Actualizează",
  new_email: "E-mail nou",
  kjuup_message: "Mesaj Kjuup",
  delete_profile: "Șterge profilul?",
  my_position: "Poziția mea:",
  add: "adaugă",
  owner_company_admin: "Administrator companie :",
  owner_company_admin_new: "Administrator companie",
  mutual_contact: "contact comun",
  mutual_contacts: "contacte comune",
  co_owner: "Co-proprietar",
  managing_director: "Director general",
  associate: "Asociat",
  secretary: "Secretar",
  employee: "Angajat",
  project_manage: "Manager proiect",
  auto_chat_translation: "Traducere automată chat",
  translate_room_group_names: "Traducere nume de grupuri de chat",
  translate_room_group_names_info: "La activare, numele grupurilor de chat sunt traduse automat în limba interfeței.",
  default_view_email: "Default View: E-Mail",
  default_view_email_info: "Când este activat, fila E-Mail se va deschide implicit în loc de Mesaje la deschiderea aplicației.",
  integrate_email_in_messages: "Integrate E-Mail in Messages",
  integrate_email_in_messages_info: "When enabled, emails from all connected accounts will appear alongside your chat messages, sorted by date.",
  language: "Limbă",
  english: "Engleză",
  german: "Germană",
  french: "Franceză",
  italian: "Italiană",
  change_language: "Schimbă limba",
  my_companies: "Companiile mele",
  employees: "Angajați",
  invite_with_a: "Invită la Kjuup",
  add_member: "Adaugă membru",
  add_user: "Adaugă utilizator",
  send_location: "Trimite locația",
  assign_admin_rights: "Ajustează dreptul de administrator",
  deactivate_company: "Dezactivează compania",
  remove_employees: "Elimină angajați",
  remove_members: "Elimină membri",
  no_user_found: "Nu s-a găsit utilizator!",
  approve: "Aprobă!",
  deselect_all: "Deselectează tot",
  select_all: "Selectează tot",
  translation_on_building_projects: "Traducere în proiecte",
  reported_capacities: "Servicii raportate",
  up_to_50m_exact: "Până la 50m exact",
  company_details_service: "Servicii companie",
  company_contact: "Contact companie",
  invite_with_link: "Invită la Kjuup",
  share_link: "Distribuie link",
  share_company_link: "Distribuie link",
  qr_code: "Cod QR",
  copy_link: "Copiază link",
  cancel_link: "Anulează link",
  who_has_confirmed_services: "Cine v-a confirmat serviciile?",
  projectss: "Proiecte",
  add_services: "Adaugă servicii",
  services: "Servicii",
  save_text: "Salvează",
  share_on: "Distribuie pe:",
  articlen: "Articol",
  invite_user_to_confirm_service:
    "Invită utilizatori să confirme servicii companiei.",
  link_copied: "Link copiat!",
  email_copied: "E-mail copiat!",
  personal_article: "Articol personal",
  company_article: "Articol companie",
  characters_remaining: "Caractere rămase",
  optional_information: "Informații opționale",
  project: "Proiect",
  projects: "Proiecte...",
  abort: "Renunță",
  preview: "Previzualizare",
  post: "Postează",
  of: "din",
  remove: "Elimină",
  free_capacity: "Portal de locuri de muncă",
  current_status_overview: "Prezentare generală status actual",
  report_capacities: "Raportează servicii",
  report_text: "Raportează",
  search_capacities: "Găsește antreprenori",
  add_project_user: "Adaugă utilizator proiect",
  media: "Media",
  links: "Link-uri",
  docs: "Documente",
  featured_products: "Produse recomandate...",
  title: "Titlu",
  text: "Text",
  feed_details: "Detalii flux",
  add_employee: "Adaugă angajat",
  latest: "Cele mai recente",
  my_projects: "Proiectele mele",
  cancel: "Anulează",
  continue: "Continuă",
  role_in_the_building_industry: "Rol în industria construcțiilor",
  als: "ca",
  join: "alătură-te",
  find: "Găsește",
  request_to_join_a_company: "Cerere de alăturare la companie",
  wants_to_join_the_company: "dorește să se alăture companiei",
  filter_by: "Filtrează după",
  ok: "Ok",
  close: "Închide",
  weekly_statistics: "Statistici săptămânale",
  is_following_you: "vă urmărește.",
  as: "ca",
  has_joined_the: "s-a alăturat companiei",
  has_looked_at_your_profile: "a vizualizat profilul dvs.",
  time: "Oră",
  in_searches_in_past_week: "în căutări în săptămâna trecută.",
  has_liked_your_article: "i-a plăcut articolul dvs.",
  has_published_a_new_article: "a publicat un articol nou.",
  you: "Dvs.",
  all_views: "Toate vizualizările",
  all_profile_views: "Toate vizualizările profilului",
  mutual_company: "companie comună",
  artical_text: "Scrie articol...",
  you_have_appeared: "Ați apărut",
  your_request_at_the_company: "Cererea dvs. la companie",
  times_you_have_appeared_in_searches: "ori ați apărut în căutări",
  appear_more_often_in_searches: "Apăreți mai des în căutări",
  you_have_been_found: "Ați fost găsit",
  improve_profile: "Îmbunătățește profilul",
  choose_existing_contact_for_single_chat:
    "Alege contact existent pentru chat individual:",
  in_order_to_add_new_contacts:
    "Pentru a adăuga contacte noi, vă rugăm să căutați contacte noi pe pagina de profil.",
  times_in_searches_in_the_last_week:
    "ori în căutări în săptămâna trecută. Actualizați profilul dvs. și adăugați detalii suplimentare pentru a fi găsit mai ușor.",
  has_been_confirmed: "a fost confirmat.",
  have_joined_the: "s-au alăturat la  ",
  building_project: " proiect de construcție.",
  select_with_which_company_you_want_to_connect_to_the_project:
    "Selectați compania pe care o veți reprezenta. Aceasta va fi afișată altor participanți.",
  select_with_which_company_you_want_to_connect_to_the_chat:
    "Selectați compania pe care o veți reprezenta. Aceasta va fi afișată altor participanți.",
  select_internal_section: "Vă rugăm să selectați secțiunea internă",
  select_profile_image: "Selectează imagine profil",
  share_user: "Distribuie utilizator",
  contact_sender_message:
    "Distribuiți acest link pentru a invita un non-membru al Kjuup la Kjuup. Acest link poate fi folosit de mai multe persoane pentru înregistrare.",
  project_sender_message:
    "Distribuiți acest link pentru a invita un non-membru al Kjuup la proiectul nume proiect. Acest link poate fi folosit de mai multe persoane pentru înregistrare și alăturare la proiectul nume proiect în Kjuup.",
  company_sender_message:
    "Distribuiți acest link pentru a invita un non-membru al Kjuup la compania nume companie. Acest link poate fi folosit de mai multe persoane pentru înregistrare și alăturare la companie în Kjuup.",
  contact_receivers_message:
    "Link de invitație pentru alăturare la Kjuup. Vă rugăm să faceți clic pe link pentru înregistrare la kjuup.",
  iphone: "iPhone:",
  iphone_recivers_message:
    "În cazul în care instalați Kjuup prin Apple App Store, trebuie să faceți clic pe acest link după descărcarea cu succes, pentru a putea să vă înregistrați.",
  project_receivers_message:
    "Link de invitație pentru alăturare la proiectul nume proiect în Kjuup. Vă rugăm să faceți clic pe link pentru înregistrare la Kjuup și alăturare la proiectul nume proiect.",
  company_receivers_message:
    "Link de invitație la compania nume companie în Kjuup. Vă rugăm să faceți clic pe link pentru înregistrare la Kjuup și alăturare la compania nume companie.",
  sign_in: "Conectare",
  enter_your_email_add: "Introduceți adresa dvs. de e-mail",
  forgot_password: "Ați uitat parola?",
  dont_have_account: "Nu aveți cont?",
  register: "Înregistrare",
  get_app: "Obține aplicația",
  registration: "Înregistrare",
  dep_ing: "Dipl.-Ing.",
  dr: "Dr.",
  dr_ing: "Dr.-Ing.",
  dep_ing_arc: "Dipl.-Ing. Arhitect",
  prof: "Prof.",
  first_name: "Prenume",
  last_name: "Nume",
  have_an_account: "Aveți cont?",
  when_register_you_agree: "La înregistrare acceptați",
  term_of_use: "termenii de utilizare",
  to: "noștri.",
  in_our: "În",
  data_policy: "politicile noastre de date",
  they_find_out: "aflați,",
  we_provide_store_data: "cum colectăm, procesăm și stocăm informații.",
  leaving_company_text:
    "Chiar doriți să părăsiți compania? Când părăsiți compania, părăsiți și toate proiectele și grupurile de chat asociate. Vă puteți realătura la aceste proiecte cu o altă companie oricând.",
  delete_profile_text:
    "Chiar doriți să ștergeți profilul dvs.? Când ștergeți profilul dvs., toate conexiunile la companii, proiecte și chat-uri vor fi eliminate. Puteți crea un profil nou oricând.",
  confirm: "Confirmă",
  reject: "Respinge",
  requet_to_leave: "Cerere de plecare",
  choose: "Alege",
  your_add_member: "Adaugă membru",
  if_you: "în cazul în care",
  can_not_find: "nu vă puteți găsi contactul aici.",
  please_wait: "Vă rugăm să așteptați..",
  imprint_gtc: "Impressum/Termeni și condiții",
  register_confirm_popup: "Verificați adresa de e-mail Kjuup înainte de a vă conecta. Am trimis un link de confirmare. Dacă nu îl vedeți, verificați și folderul spam.",
  PENDING_GROUP_USER:
    "va primi mesaje doar după ce invitația la proiect a fost confirmată. Un mesaj suplimentar va apărea odată ce invitația la proiect a fost confirmată.",
  PENDING: "Confirmarea invitației la proiect în așteptare",
  denied_group_chat: " a respins invitația la proiect și a părăsit acest grup.",
  // joined_group_chat: " s-a alăturat proiectului și acestui grup.",
  joined_group_chat: " s-a alăturat acestui grup",
  you_joined_group_chat: "V-ați alăturat acestui grup.",
  Others: "Alții",
  LEFT_GROUP: "a părăsit acest grup de chat.",
  YOU_LEFT_GROUP: "ați părăsit acest grup de chat.",
  days: "zile",
  day: "zi",
  hour: "oră",
  hide_project: "Ascunde proiectul",
  hide_project_popup_text:
    "Dacă ascundeți proiectele, acestea nu pot fi găsite în Kjuup. Doar membrii proiectului pot invita utilizatori noi la proiect.",
  branch: "Ramura",
  photo_video_media_lib: "Bibliotecă media - Foto și video",
  document: "Document",
  location_meeting: "Locație / Întâlnire",
  all_member_of_project: "Toți membrii proiectului",
  pending_request: "Cereri de proiect în așteptare",
  no_pending_request: "Nu s-au găsit cereri în așteptare!",
  news_feed: "Flux de știri",
  user_info: "Informații grup",
  leave_project: "Părăsește proiectul",
  media_link_docs: "Fișiere",
  search_chat: "Caută în chat",
  export_chat_group: "Exportă date grup chat din luna trecută",
  request_complete_chat_history: "Solicită istoric complet chat",
  leave_chat_group: "Părăsește grup chat",
  add_user_project: "Adaugă utilizator",
  me: "Eu",
  max_open_one_to_one:
    "În prezent max. 2 chat-uri unu la unu pot fi deschise în paralel în secțiunea de jos și de sus. În total max. 4 chat-uri unu la unu sunt posibile.",
  are_you_sure_you_want_leave_chat:
    "Sunteți sigur că doriți să părăsiți acest grup de chat?",
  create_group: "Creează grup",
  adding_members: "Se adaugă membri...",
  creating_the_chat: "Se creează chatul...",
  finishing_setup: "Se finalizează...",
  group_name: "Nume grup",
  by: "De:",
  mandetory: "*obligatoriu",
  delteed: "a șters profilul său și a părăsit chat-ul de grup.",
  deleted_direct: "a șters profilul său și a părăsit chat-ul.",
  unhidden_message:
    "Dacă nu ascundeți proiectele, acestea pot fi găsite de toți membrii Kjuup.",
  account_deleted: "Contul a fost șters.",
  refuse_company: "Sunteți sigur că doriți să refuzați invitația companiei?",
  follow_additional: "Urmărește utilizatori suplimentari",
  f_add:
    "Urmăriți utilizatori suplimentari ai Kjuup pentru a-i face disponibili pentru mesaje directe.",
  c_inv: "Invitație(i) companie",
  invited_o_Company: "Ați fost invitat să vă alăturați companiei",
  refuse_companyX: "Sunteți sigur că doriți să refuzați cererea companiei?",
  a_Da: "Cont dezactivat.",
  has_deactivated: "a dezactivat profilul său.",
  reactive: "a reactivat profilul său.",
  juup_note: "*Înregistrarea cu nume de utilizator disponibilă doar pentru membrii Kjuup+",
  username: "Nume utilizator*",
  email_username: "E-mail/Nume utilizator*",
  sPinText:
    "Vă rugăm să furnizați un PIN de securitate cu 6 cifre. Acest PIN va fi necesar în cazul în care uitați parola și este obligatoriu pentru confirmarea contului dvs.",
  DeleteKjuupPlusText:
    "Chiar doriți să ștergeți profilul dvs.? Când ștergeți profilul dvs., toate conexiunile la companii, proiecte și chat-uri vor fi eliminate.\n\nÎn termen de 48 de ore după ștergerea contului, puteți reactiva contul dvs. conectându-vă cu nume de utilizator, parolă și PIN.",
  reactive_text:
    "Contul dvs. a fost șters. Vă rugăm să faceți clic pe Reactivare pentru a reactiva contul dvs.",
  rac: "Reactivează",
  ac_ss: "Cont reactivat cu succes.",
  not_valid_pin: "PIN invalid",
  only_for_kjuup:
    "*Resetarea parolei prin nume de utilizator și PIN disponibilă doar pentru membrii Kjuup+.",
  resetPIN: "Resetează PIN",
  enter_current_pin: "Vă rugăm să introduceți PIN-ul dvs. actual",
  enter_new: "Introduceți PIN nou",
  pin_to_confirm: "Vă rugăm să furnizați PIN-ul pentru confirmare.",
  change_username: "Resetează nume utilizator",
  pp_not_match: "Parola și Confirmarea parolei nu se potrivesc",
  reactive_itself: "Ați reactivat profilul dvs.",
  has_deactivated_itself: "Ați dezactivat profilul dvs.",
  more_than_two:
    "În prezent mesajele directe pot fi făcute doar cu 2 utilizatori în paralel.",
  Chats: "Mesaje directe",
  only_in_mobileL:
    "Videoclipurile native pot fi în prezent încărcate și postate doar prin aplicația mobilă. Vă rugăm să folosiți link-uri video de pe Youtube și Vimeo.",
  register_pin_text:
    "Vă rugăm să alegeți PIN-ul dvs. personal cu 6 cifre. Acest PIN va fi necesar pentru a activa funcționalitățile de resetare a contului.",
  internal_project: "Intern",
  external_projects: "Extern",
  in_deacticted: "Secțiunea internă este dezactivată.",
  create_article: "Creează articol",
  new_article_selection: "Creează articol pentru flux știri extern",
  new_article_selection_internal: "Creează articol intern",
  active_trans_title: "Activați traducerea automată?",
  active_trans: "Când este activată, toate mesajele de chat primite vor fi traduse în limba aplicației selectate.",
  disable_trans: "Chiar doriți să dezactivați traducerea automată?",
  allow_access_chat: "Afișează istoric complet chat",
  toggle_chat_history_on:
    "Chiar doriți ca utilizatorul să vadă istoricul complet al chat-ului?",
  toggle_chat_history_off:
    "Chiar doriți ca utilizatorul să vadă doar istoricul chat-ului din momentul alăturării la chat?",
  check_selected_settings:
    "Vă rugăm să verificați setările pentru istoricul chat-ului pentru toți utilizatorii selectați!",
  chat_from_start_have:
    "V-ați alăturat acestui grup. Istoricul chat-ului a fost distribuit.",
  chat_from_start_has:
    "s-a alăturat acestui grup. Istoricul chat-ului a fost distribuit.",
  Address: "Adresă",
  read_by: "Citit de",
  deliver_to: "Livrat la",
  remaining: "rămas",
  message_info: "Informații mesaj",
  request_to_join_only: "Cerere de alăturare",
  unfollow: "Nu mai urmări",
  company_username: "Nume utilizator",
  month: [
    "Ian",
    "Feb",
    "Mar",
    "Apr",
    "Mai",
    "Iun",
    "Iul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ],
  remove_my_admin_right: "Elimină drepturile mele de administrator",
  makeEmp: "Chiar doriți să eliminați drepturile de administrator companie de la utilizator?",
  remove_my_self:
    "Chiar doriți să eliminați drepturile de administrator companie din contul dvs.?",
  makeAdmin: "Chiar doriți să acordați utilizatorului drepturi de administrator companie?",
  remove_member: "Elimină membru",
  remove_following_confirm: "Chiar doriți să eliminați {name} din lista urmăriți?",
  remove_follower_confirm: "Chiar doriți să eliminați {name} din cei care vă urmăresc? Dacă îl/o eliminați, nu va fi informat/ă.",
  do_you_really_want_to_remove:
    "Chiar doriți să eliminați numele de utilizator din companie?",
  invite_all: "Invită toți membrii companiei",
  invite_all_members: "Invită toți membrii",
  mems: "Toți ceilalți membri",
  dep_loc: "Departament/Locație/Echipă",
  depAdmin: "Administrator departament",
  add_remove_admin: "Adaugă/Elimină poziție administrator companie",
  add_remove_dep_admin: "Adaugă/Elimină poziție administrator departament",
  remove_employees_dept: "Elimină angajați din",
  want_to_join_dep:
    "Nume utilizator dorește să se alăture Departamentului/Locației/Echipei depname a companiei companyname.",
  you_invited:
    "Ați fost invitat să vă alăturați Departamentului/Locației/Echipei depname a companiei companyname.",
  dep_remove:
    "Chiar doriți să eliminați drepturile de administrator departament sau locație de la utilizator?",
  add_dep:
    "Chiar doriți să acordați utilizatorului drepturi de administrator pentru departament sau locație?",
  my_self_dep_remove:
    "Chiar doriți să eliminați drepturile de administrator departament din contul dvs.?",
  member: "Membru",
  admin: "Administrator",
  remove_project_admin:
    "Chiar doriți să eliminați membrul din proiect?",
  remove_my_self_project: "Chiar doriți să eliminați drepturile de administrator?",
  remove_member_admin_right:
    "Chiar doriți să eliminați drepturile de administrator de la utilizator?",
  add_member_admin_right: "Chiar doriți să adăugați drepturi de administrator utilizatorului?",
  add_remove_Poss: "Adaugă/Elimină poziție administrator",
  forward: "Transmite",
  edit: "Editează",
  only_kjuup_plus_can: "Doar companiile Kjuup+ pot posta articole.",
  add_images: "Adaugă imagine(i)",
  request_confirmation: 'Invitații de proiect în așteptare',
  Activity: "Activitate",
  latest_messages: "Cele mai recente mesaje",
  hours: "ore",
  minute: "minute",
  seconds: "secunde",
  days: "zile",
  yesterday: "ieri",
  last_week: "săptămâna trecută",
  next_week: "săptămâna viitoare",
  Last_month: "luna trecută",
  All: "Toate",
  register_plus: "Înregistrare Plus",
  select_files: "Selectează fișiere",
  monthsFullName: [
    "Ianuarie",
    "Februarie",
    "Martie",
    "Aprilie",
    "Mai",
    "Iunie",
    "Iulie",
    "August",
    "Septembrie",
    "Octombrie",
    "Noiembrie",
    "Decembrie",
  ],
  company_deploc_receivers_message:
    "Link de invitație la departamentul companiei nume companie în Kjuup. Vă rugăm să faceți clic pe link pentru înregistrare la Kjuup și alăturare la compania nume companie.",
  no_news: "Nu sunt disponibile știri",
  reminder: "Memento",
  np_reminder: "Fără sarcini",
  move_to_reminder: "Mută la sarcină",
  remove_reminder: "Chiar doriți să eliminați acest mesaj din lista dvs. de sarcini?",
  remove_all_reminder: "Elimină toate sarcinile",
  remove_all_confirm: "Chiar doriți să eliminați toate mesajele din lista dvs. de sarcini?",
  remove_from_reminder: "Elimină din memento",
  prevent_email: "E-mail-ul nu poate fi folosit ca Nume utilizator.",
  allow_noti: "Vă rugăm să permiteți notificările.",
  join_cap: "Alătură-te",
  pass_minimum:
    "**Parola necesită 12 caractere incl. literă mică, literă mare, cifră și caracter special.",
  pass_error: "Vă rugăm să verificați cerințele parolei",
  people_that_like_article: "Oameni cărora le place articolul.",
  people_who_like_article: "Oameni cărora le place articolul dvs.",
  message_delete: "Acest mesaj a fost șters.",
  message_edited: "editat",
  edit_message: "Editează mesajul",
  edit_window_expired: "Mesajele pot fi editate doar în 10 minute de la trimitere.",
  message_edit_save: "Salvează",
  copy: "Copiază",
  bookmark: "Semn de carte",
  add_reaction: "Adaugă reacție",
  delete_message: "Șterge mesajul",
  more_options: "Mai multe opțiuni",
  info: "Info",
  link_invite: "Invită prin link",
  ll_nkk: "Invită la Kjuup",
  selected: "Selectat",
  is_active: "Activ",
  inactive: "Inactiv",
  last_online: "văzut ultima dată {{when}}",
  remove_user_l: "Elimină",
  link_expire: "Fiecare link generat va fi valabil timp de 72 de ore.",
  company_language: "Limba companiei",
  company_language_info:
    "Selectarea limbii va fi folosită pentru toate confirmările prin e-mail referitoare la companie.",
  s_image: "imagine",
  m_image: "imagini",
  removeMsg: "Atingeți pentru eliminare",
  block: 'Blochează',
  unblock: 'Deblochează',
  blocks: 'Sunteți sigur că doriți să blocați acest utilizator?',
  unblocks: 'Sunteți sigur că doriți să deblocați acest utilizator?',
  bolcked_click_un_block:
    'Ați blocat acest contact. Faceți clic aici pentru a elimina blocarea.',
  you_have_unblocked: 'Ați deblocat acest contact.',
  you_have_blocked: 'Ați blocat acest contact.',
  unblock_to_send: 'Deblochează utilizator pentru a trimite mesaj.',
  pilot_text: "AI specializat pentru subiecte de construcții",
  startup_screen_label: "Ecran de pornire",
  startup_screen_info: "Alegeți ce ecran se deschide la pornirea Kjuup.",
  startup_screen_feed: "Home",
  startup_screen_messages: "Mesaje",
  startup_screen_saved: "Ecranul de pornire a fost actualizat",
email_on: "Notificări e-mail chat-uri",
  email_on_grp: "Notificare e-mail",
  article_email_on: "Email notification articles",
  article_email_info: "If you enable email notifications for internal articles, you will receive an email when a new internal article is published in your company and department.",
  info_email_room: "Activează sau dezactivează notificările e-mail pentru acest proiect. Această opțiune este disponibilă doar când \"Notificări e-mail chat-uri\" este activată prin setările personale.",
  todo_notification_info: "Veți fi notificat de fiecare dată când vă este atribuită o nouă sarcină.",
  info_val: "Vei primi un e-mail dacă un mesaj nou din chat nu este citit într-un timp scurt. Poți dezactiva acest lucru pentru anumite proiecte sau chat-uri în setările lor sau în informațiile grupului de chat.",
  email_groups: "Activează sau dezactivează notificările e-mail pentru acest chat. Această opțiune este disponibilă doar când \"Notificări e-mail chat-uri\" este activată prin setările personale și ale proiectului.",
  add_update_email: "Adaugă/Actualizează e-mail",
  text_to_verifiy: "Opțiunea \"Notificări e-mail chat-uri\" poate fi activată doar dacă aveți o adresă de e-mail verificată în dosar.",
  stored_email: "E-mail stocat: ",
  verify_email: "Confirmare în așteptare!",
  join_call:"Alătură-te",
  call_is_started:"Apelul a început",
  start_chat:"Începe chat direct?",
  project_rooms:"Proiecte",
  download_selected:"Descarcă",
  add_employee_confirm: 'Sunteți sigur că doriți să adăugați acest utilizator la companie?',
  invalid_deeplink: "URL link profund invalid. Lipsesc parametri necesari.",
  deeplink_error: "Nu se poate procesa link-ul profund. Vă rugăm să încercați din nou mai târziu.",
  // Reply functionality translations
  reply: "Răspunde",
  reply_enter: "Introduceți răspuns...",
  reply_sent_successfully: "Răspuns trimis cu succes",
  reply_failed: "Trimiterea răspunsului a eșuat",
  reply_failed_generic: "Trimiterea răspunsului a eșuat. Vă rugăm să încercați din nou.",
  replying_to_message: "Răspunde la mesaj",
  cancel_reply: "Anulează răspuns",
  voice_message: "Mesaj vocal",
  send: "Trimite",
  cancel: "Anulează",
  type_your_reply: "Tastați răspunsul dvs....",
  
  // Auto-suggestion translations
  suggested_replies: "Răspunsuri sugerate",
  suggestions_error: "Încărcarea sugestiilor a eșuat",
  positive_suggestion_placeholder: "Positive",
  neutral_suggestion_placeholder: "Neutral",
  negative_suggestion_placeholder: "Negative",
  lazy_media_image: "Image — Click to load",
  lazy_media_audio: "Voice message — Click to load",
  lazy_media_doc: "Document — Click to load",
  lazy_media_video: "Video — Click to load",
  suggestion_loading_message: "Un moment. Textul dvs. este pregătit individual pentru dvs.",
  loading_chat_message: "Se încarcă chat-ul...",
  
  // Manual ToDo translations
  extracting_message: "Se extrage mesajul...",
  create_todo: "Creează sarcină",
  create_todo_confirmation: "Doriți să creați o sarcină din acest mesaj?",
  select_project_required: "Vă rugăm să selectați un proiect/grup",
  only_assigned_can_change_status: "Doar utilizatorii atribuiți pot schimba statusul",
  todo_summary: "Rezumat",
  todo_summary_placeholder: "Introduceți rezumatul sarcinii...",
  todo_date: "Dată",
  todo_time: "Oră",
  todo_date_hint: "Lăsați gol pentru a folosi data/ora mesajului original",
  todo_created_success: "Sarcină creată cu succes",
  todo_creation_failed: "Crearea sarcinii a eșuat",
  create: "Creează",
  
  image: "imagine",
  images: "imagini",
  remove_all_images: "Elimină toate imaginile",
  remove_image: "Elimină imagine",
  remove_document: "Elimină document",
  remove_recording: "Elimină înregistrare",
  play_recording: "Redă înregistrare",
  upload_image: "Încarcă imagine",
  upload_document: "Încarcă document",
  record_audio: "Înregistrează audio",
  stop_recording: "Oprește înregistrarea",
  stop_recording_text: "Oprește înregistrarea",
  please_remove_current_attachment: "Vă rugăm să eliminați atașamentul curent pentru",
  please_upload_image_file: "Vă rugăm să încărcați un fișier imagine valid",
  please_upload_valid_document: "Vă rugăm să încărcați un fișier document valid",
  searching_messages: "Căutare mesaje...",
  loading_more: "Se încarcă mai mult...",
  loading_more_users: "Se încarcă mai mulți utilizatori...",
  load_more_users: "Încarcă mai mulți utilizatori",
  no_more_users_to_load: "Nu mai sunt utilizatori de încărcat",
  no_messages_found: "Nu s-au găsit mesaje",
  try_different_keyword: "Încercați un alt cuvânt cheie sau verificați ortografia.",
  search_messages: "Caută mesaje, grupuri de chat, proiecte și utilizatori...",
  todo: "Sarcină",
  np_todo: "Fără sarcini",
  move_to_todo: "Salvează ca sarcină",
  remove_todo: "Chiar doriți să eliminați sarcina?",
  remove_all_todo: "Elimină toate sarcinile",
  remove_all_todo_confirm: "Chiar doriți să eliminați toate sarcinile?",
  add_to_todo: "Adaugă la sarcină",
  remove_from_todo: "Elimină din sarcină",
  confirm: "Confirmă",
  ok: "Ok",
  read_more: "Citește mai mult",
  show_less: "Afișează mai puțin",
  show_more: "Afișează mai mult",
  audio: "Audio",
  video: "Video",
  // Notification Settings
  notification_schedule: "Program notificări",
  notification_schedule_desc: "Veți primi notificări push și e-mail doar în orele pe care le alegeți. În afara acestor ore, vor fi oprite.",
  learn_more: "Află mai mult",
  allow_notifications: "Permite notificări:",
  every_day: "În fiecare zi",
  weekdays: "Zile lucrătoare (luni până vineri)",
  custom: "Personalizat",
  monday: "Luni",
  tuesday: "Marți",
  wednesday: "Miercuri",
  thursday: "Joi",
  friday: "Vineri",
  saturday: "Sâmbătă",
  sunday: "Duminică",
  to: "până la",
  notification_settings: "Notificări",
  notification_settings_saved: "Setările de notificare au fost salvate cu succes",
  notification_settings_error: "Salvarea setărilor de notificare a eșuat",
  unavailability_note: "Notă de indisponibilitate",
  unavailability_description: "Setați o notă de absență. Cât timp este activă, nota este afișată celorlalți în toate chat-urile și notificările sunt suspendate.",
  unavailability_start_date: "Data de început",
  unavailability_end_date: "Data de sfârșit",
  unavailability_message: "Mesaj",
  unavailability_message_hint: "Folosiți {endDate} ca substituent pentru data de revenire.",
  unavailability_replacement: "Contact de înlocuire",
  unavailability_replacement_placeholder: "Introduceți ID-ul utilizatorului pentru solicitări urgente",
  unavailability_replacement_current: "Înlocuitor actual",
  unavailability_replacement_hint: "Dacă este setat, un link pentru a contacta această persoană pentru chestiuni urgente va fi afișat în nota de indisponibilitate.",
  unavailability_replacement_none: "Fără înlocuitor (opțional)",
  unavailability_contact_urgent: "Pentru solicitări urgente contactați",
  unavailability_default_message: "În prezent nu sunt la birou și nu am acces la Kjuup. Voi fi din nou disponibil(ă) începând cu {endDate} și vă voi contacta atunci.",
  unavailability_save: "Salvează",
  unavailability_deactivate: "Dezactivează",
  unavailability_active_until: "Activ până la",
  unavailability_saved: "Nota de indisponibilitate a fost salvată",
  unavailability_save_error: "Eroare la salvarea notei de indisponibilitate",
  unavailability_deactivated: "Nota de indisponibilitate a fost dezactivată",
  unavailability_end_date_required: "Data de sfârșit este obligatorie",
  start_time_before_end_time: "Ora de început trebuie să fie înainte de ora de sfârșit",
  loading: "Se încarcă",
  disabled: "Dezactivat",
  enable: "Activează",
  disable: "Dezactivează",
  forwarded: "Transmis",
  message_forwarded: "Mesaj transmis!",
  // Schedule Article
  schedule_article_post: "Programează postarea articolului",
  date: "Dată",
  time: "Oră",
  scheduled_for_publication: "Programat pentru publicare",
  article_will_be_published_on: "Articolul va fi publicat pe:",
  reset_selection: "Resetează selecția",
  continue: "Continuă",
  cancel: "Anulează",
  // Member Selection
  error_loading_members: "Eroare la încărcarea membrilor",
  please_fill_all_fields: "Vă rugăm să completați toate câmpurile",
  invalid_email: "Adresă e-mail invalidă",
  member_added_successfully: "Membru adăugat cu succes",
  error_onboarding_user: "Eroare la adăugarea utilizatorului",
  error_creating_chat: "Eroare la crearea chat-ului",
  error_creating_group: "Eroare la crearea grupului",
  new_group: "Grup nou",
  please_select_or_enter_group_name: "Vă rugăm să selectați un grup sau să introduceți numele grupului",
  please_select_or_enter_room_name: "Vă rugăm să selectați un proiect sau să introduceți numele proiectului",
  error_creating_room: "Eroare la crearea proiectului",
  error_opening_chat: "Eroare la deschiderea chat-ului",
  privacy_modal_text: "Selectați \"Privat\" doar dacă chat-ul nu conține conținut profesional relevant pentru managerul de proiect.",
  not_private: "Nu este privat",
  private: "Privat",
  error_loading_groups: "Eroare la încărcarea grupurilor",
  automatic_chat_export: "Export automat chat",
  automatic_chat_export_info: "După activare, istoricul chat-ului va fi trimis automat la adresa de e-mail specificată în fiecare lună.",
  automatic_chat_export_no_email: "Pentru a activa exportul automat al chat-ului, trebuie mai întâi să adăugați o adresă de e-mail. Puteți adăuga adresa de e-mail în setările personale.",
  enter_email: "Introduceți e-mail",
  update: "Actualizează",
  confirm: "Confirmă",
  export_to_email: "Exportul merge la următorul e-mail.",
  start_chat_button:"Mesaj nou",
  matching_existing_chats: "Chat-uri existente care se potrivesc",
  subject: "Subiect",
  add_subject: "Adaugă subiect",
  chat_subject: "Subiect chat:",
  set_project_room: "Setează proiectul",
  matching_existing_project_rooms: "Proiecte existente care se potrivesc",
  name_project_room: "Denumește proiectul",
  professional_or_private: "Profesional sau privat",
  professional: "Profesional",
  privacy_modal_text_updated: "Selectați \"Privat\" doar dacă chat-ul nu conține conținut profesional relevant pentru managerii de proiect. Chat-urile private nu sunt vizibile pentru managerii de proiect.",
  create_internal_chat: "Chat extern sau intern?",
  internal_chat_description: "Doar angajații companiei dvs. pot fi adăugați la chat-uri interne.",
  yes: "Da",
  no: "Nu",
  chat_is_being_created: "Chat-ul se creează...",
  // Additional translations for hardcoded text
  discard_article_confirm: "Chiar doriți să renunțați la modificările acestui articol?",
  please_enter_article_title: "Vă rugăm să introduceți mai întâi titlul articolului.",
  please_add_mandatory_fields: "Vă rugăm să adăugați toate câmpurile obligatorii",
  product_label: "Produs:",
  no_companies_found: "Nu s-au găsit companii",
  visible_to_all_followers: "Vizibil pentru toți membrii Kjuup",
  only_visible_to_employees: "Vizibil doar pentru angajați",
  something_went_wrong: "Ceva a mers greșit, vă rugăm să încercați din nou",
  please_select_department: "Vă rugăm să selectați departament/locație",
  schedule: "Programează",
  please_select_future_date_time: "Vă rugăm să selectați o dată și oră viitoare pentru programarea articolului.",
  please_select_different_date_time: "Vă rugăm să selectați o altă dată sau oră pentru programarea articolului.",
  please_select_later_time: "Vă rugăm să selectați o oră mai târzie decât ora curentă pentru astăzi.",
  unpin_article: "Anulează fixarea articolului",
  pin_article: "Fixează articolul",
  and: "și",
  others: "alții",
  at: "la",
  // Chat mute/unmute translations
  mute: "Dezactivează sunet",
  unmute: "Activează sunet",
  chat_muted_successfully: "Chat-ul a fost dezactivat cu succes",
  chat_unmuted_successfully: "Sunetul chat-ului a fost activat cu succes",
  mute_chat_confirm: "Chiar doriți să dezactivați sunetul acestui chat? Nu veți mai primi notificări pentru mesaje noi.",
  unmute_chat_confirm: "Chiar doriți să activați sunetul acestui chat? Veți primi din nou notificări pentru mesaje noi.",
  please_select_group_to_forward: "Vă rugăm să selectați grupul pentru transmiterea mesajului",
  // Company translations
  record_not_found: "Înregistrare negăsită!",
  please_select_position: "Vă rugăm să selectați poziția",
  delete_article_confirm: "Sunteți sigur că doriți să ștergeți acest articol?",
  delete_company_service_confirm: "Sunteți sigur că doriți să ștergeți serviciul companiei?",
  block_translation_confirm: "Chiar doriți să blocați traducerea automată în proiecte pentru toți membrii companiei",
  unblock_translation_confirm: "Chiar doriți să deblocați traducerea automată în proiecte pentru toți membrii companiei",
  please_select_file: "Vă rugăm să selectați un fișier pentru încărcare",
  role_in_building_industry: "Rol în industria construcțiilor*",
  invalid_email_address: "Adresă e-mail invalidă",
  please_enter_password: "Vă rugăm să introduceți parola",
  password_change_email_sent: "Un e-mail a fost trimis la adresa dvs. de e-mail Kjuup. Confirmați noua parolă făcând clic pe linkul de confirmare din e-mail.",
  please_enter_username: "Vă rugăm să introduceți numele de utilizator",
  username_same_as_before: "Numele de utilizator nu poate fi același ca înainte",
  profile_deleted_successfully: "Profil șters cu succes",
  hardware_requirements: "Cerințe hardware",
  hardware_requirements_list: "• 4GB RAM<br/>• Viteză CPU min. 2GHz<br/>• Windows 7 sau mai nou / toate versiunile macOS",
  submitting: "Se trimite...",
  signing_in: "Se conectează...",
  please_enter_service_name: "Vă rugăm să introduceți numele serviciului",
  something_went_wrong_error: "Aaaah! Ceva a mers greșit...",
  something_went_wrong_try_again: "Ne pare rău, ceva a mers greșit acolo. Încercați din nou",
  position_label: "Poziție:",
  loading_room: "Se încarcă proiectul...",
  navigating_to_room: "Navigare către proiect",
  loading_chat: "Se încarcă chat-ul...",
  translate: "Traduce",
  show_original: "Afișează originalul",
  saving: "Se salvează...",
  language_selection_info: "Selectarea limbii este folosită pentru toate confirmările prin e-mail referitoare la companie.",
  // Navigation bar labels
  nav_call: "Apel",
  nav_home: "Acasă",
  nav_messages: "Mesaje",
  nav_todo: "Sarcini",
  nav_rooms: "Proiecte",
  nav_all_rooms: "Toate proiectele",
  pinned_rooms_max: "Puteți fixa până la 10 proiecte.",
  pinned_room_unpin: "Anulare",
  pinned_rooms_drop: "Trageți proiectul aici pentru selecție rapidă",
  nav_profile: "Profil",
  nav_company: "Companie",
  nav_company_documents: "Documente",
  nav_logout: "Deconectare",
  // Create message dialog
  add_member_title: "Adaugă membru",
  continue_btn: "Continuă",
  search_placeholder: "Căutare",
  no_members_found: "Nu s-au găsit membri",
  no_groups_found: "Nu s-au găsit grupuri",
  no_rooms_found: "Nu s-au găsit proiecte",
  search_users_tab: "Utilizatori",
  search_documents_tab: "Documente",
  company_documents: "Company documents",
  company_documents_empty: "No documents available.",
  no_media_available: "Niciun fișier",
  no_documents_available: "No documents",
  searching_users: "Se caută utilizatori...",
  no_users_found: "Niciun utilizator găsit",
  search_emails_tab: "E-mail",
  searching_emails: "Se caută e-mailuri...",
  no_emails_found: "Nu s-au găsit e-mailuri",
  search_email_addresses_tab: "E-Mail Addresses",
  search_email_content_tab: "E-Mail Content",
  searching_email_content: "Searching email content...",
  no_email_content_found: "No email content found",
  search_email_attachments_tab: "E-Mail Attachments",
  searching_email_attachments: "Searching attachments...",
  no_email_attachments_found: "No attachment matches found",
  email_attachments_label: "Attachments",  searching_email_addresses: "Searching addresses...",
  no_email_addresses_found: "No address matches found",
  email_subject_label: "Subject",
  email_body_label: "Body",
  email_address_received: "Received",
  email_address_sent: "Sent",
  unnamed_group: "Grup fără nume",
  unnamed_room: "Proiect fără nume",
  all_members: "Toate",
  room_label: "Proiect:",
  subject_label: "Subiect:",
  no_members: "Fără membri",
  // Loading states for room creation
  creating_structure: "Se creează structura dvs.",
  opening_chat: "Se deschide chat-ul",
  please_wait: "Vă rugăm să așteptați...",
  // ToDo page translations
  loading_todo: "Se încarcă ToDo...",
  task_updated: "Sarcină actualizată",
  error_updating_task: "Eroare la actualizarea sarcinii",
  task_deleted: "Sarcină ștearsă",
  error_deleting_task: "Eroare la ștergerea sarcinii",
  delete_task_confirm: "Sunteți sigur că doriți să ștergeți această sarcină?",
  description_label: "Descriere",
  description_placeholder: "Introduceți descrierea...",
  date_time_label: "Dată și oră",
  save_hint: "Ctrl+Enter pentru salvare, Esc pentru anulare",
  edit_label: "Editează",
  delete_label: "Șterge",
  todo_list_title: "Sarcini",
  tasks_count: "sarcini",
  search_placeholder_todo: "Căutare...",
  select_task_to_open_chat: "Selectați o sarcină pentru a deschide chat-ul",
  today: "Astăzi",
  yesterday: "Ieri",
  time_suffix: "", // Empty for Romanian (24h format doesn't need suffix)
  from_chat: "Sarcină sursă",
  assigned_to: "Atribuit la",
  assign_users: "Atribuie utilizatori",
  no_users_assigned: "Fără utilizatori atribuiți",
  assign: "Atribuie",
  assign_to: "Atribuie la...",
  navigate_to_chat: "Navighează la chat",
  navigate_to_email: "Mergi la e-mail",
  show_original_message: "Afișează sursa",
  hide_original_message: "Ascunde sursa",
  status_pending: "În așteptare",
  status_in_progress: "În progres",
  status_completed: "Finalizat",
  show: "Afișează",
  close: "Închide",
  status_confirmed: "Confirmat",
  log_todo_created: "Sarcină creată",
  log_todo_confirmed: "Sarcină confirmată",
  log_todo_deleted: "Sarcină ștearsă",
  log_todo_updated: "Sarcină actualizată",
  log_description_updated: "Descriere actualizată",
  log_deadline_updated: "Termen actualizat",
  log_assigned_to: "Atribuit la {name}",
  log_unassigned_from: "Dezatribuit de la {name}",
  log_assignment_added: "Atribuire adăugată: {name}",
  log_assignment_removed: "Atribuire eliminată: {name}",
  log_status_updated: "Status schimbat de la {from} la {to}",
  log_status_changed: "Status schimbat",
  log_status_changed_to: "Status schimbat la {status}",
  log_changed_status_to: "A schimbat statusul la:",
  log_for_user: "pentru utilizator:",
  log_user_updated_status: "Utilizatorul și-a actualizat statusul sarcinii",
  log_changed_date_to: "A schimbat data la:",
  log_changed_description_to: "A schimbat descrierea la:",
  log_moved_to: "Mutat la {status}",
  todo_status_updated_from: "de la",
  todo_status_updated_to: "la",
  filter_pending: "În așteptare",
  filter_confirmed: "Confirmat",
  filter_assigned_to_me: "Sarcinile mele",
  filter_assigned_by_me: "Delegat",
  todo_project_label: "Proiect:",
  assigned_users: "Utilizatori atribuiți:",
  todo_chat_label: "Chat:",
  history: "Istoric",
  todo_assigned_by: "Atribuit de:",
  todo_assigned_push: "ToDo atribuit:",
  todo_assigned_push_empty: "Ți-a fost atribuit un ToDo nou.",
  search_groups: "Grupuri",
  search_chat_groups: "Grupuri de chat",
  search_project_room: "Proiect",
  search_messages_tab: "Mesaje",
  searching_groups: "Se caută grupuri...",
  searching_rooms: "Se caută proiecte...",
  no_groups_found: "Nu s-au găsit grupuri",
  no_rooms_found: "Nu s-au găsit proiecte",
  create_poll: "Sondaj",
  poll_question_label: "ÎNTREBARE",
  poll_question_placeholder: "Puneți o întrebare",
  poll_options_label: "OPȚIUNI",
  poll_option: "Opțiune",
  poll_add_option: "Adăugați opțiune",
  poll_allow_multiple: "Permiteți răspunsuri multiple",
  poll_multiple_allowed: "Selectați una sau mai multe opțiuni",
  poll_select_option: "Selectați o opțiune",
  poll_view_votes: "Vizualizați voturile",
  poll_vote_singular: "vot",
  poll_vote_plural: "voturi",
  poll_votes: "Rezultate vot",
  poll_no_votes_yet: "Încă nu sunt voturi",
  transcript_step_processing: "Transcriere în curs...",
  ai_transcript_tab: "AI-Transcriere",
  ai_transcript_info: "Disponibil doar pentru mesajele vocale create după 09.03.2026.",
  transcript_more: "...mai mult",
  transcript_less: "...mai puțin",
  ki_transcript_voice_message: "KI-Transcriere mesaj vocal",
  ki_image_analysis: "Analiză de imagine asistată de AI",
  type_message: "Scrieți un mesaj",
  email_tab_messages: "Mesaje",
  email_tab_email: "E-mail",
  email_tab_messages_and_email: "Messages & E-Mail",
  email_tab_email_details: "E-Mail Details",
  email_accounts: "Conturi e-mail",
  email_connect_gmail: "Conectează Gmail",
  email_connect_outlook: "Conectează Outlook",
  email_no_accounts: "Niciun cont e-mail conectat",
  email_no_accounts_hint: "Conectează un cont e-mail în setările profilului",
  email_no_messages: "Niciun e-mail",
  email_from: "De la",
  email_to: "Către",
  email_subject: "Subiect",
  email_disconnect: "Deconectează",
  email_disconnect_confirm: "Sigur doriți să deconectați acest cont de e-mail? Toate e-mailurile sincronizate vor fi eliminate.",
  email_account_disconnected: "Contul de e-mail a fost deconectat cu succes",
  email_account_disconnect_failed: "Nu s-a putut deconecta contul",
  email_connecting: "Conectare...",
  email_account_connected: "Cont conectat cu succes",
  email_signature: "Signature",
  email_signature_placeholder: "Enter your email signature...",
  email_signature_save: "Save",
  email_signature_saved: "Saved",
  email_go_to_settings: "Mergi la setări",
  email_date: "Dată",
  email_reply: "Răspunde",
  email_forward: "Transmite",
  email_copy_text: "Copiază textul",
  email_text_copied: "Copiat!",
  email_text_copy_failed: "Textul nu a putut fi copiat.",
  email_delete: "Șterge",
  email_not_spam: "Nu este spam",
  email_not_spam_success: "E-mailul a fost mutat în inbox.",
  email_not_spam_failed: "Mutarea în inbox a eșuat.",
  email_delete_confirm: "Sigur doriți să ștergeți acest e-mail?",
  email_delete_from_folder: "Sigur doriți să ștergeți din {folder}?",
  email_delete_permanent_from_folder:
    "Sigur doriți să ștergeți definitiv din {folder}? Această acțiune nu poate fi anulată.",
  email_save_draft_confirm: "Doriți să salvați acest e-mail ca ciornă?",
  email_save_draft: "Salvare ciornă",
  email_discard: "Renunțare",
  email_back_to_compose: "Înapoi la redactare",
  email_draft_saved: "Ciorna a fost salvată.",
  email_draft_save_failed: "Salvarea ciornei a eșuat.",
  email_loading: "Se încarcă e-mailurile...",
  email_archived: "Archived",
  email_mark_spam: "Mark as spam",
  email_marked_spam: "Marked as spam",
  email_group_today: "Today",
  email_group_yesterday: "Yesterday",
  email_group_this_week: "This week",
  email_group_earlier: "Earlier",
  email_search: "Search",
  email_search_placeholder: "Search mail",
  email_no_results: "No matching messages",
  email_clear_search: "Clear search",
  email_star: "Star",
  email_unstar: "Unstar",
  email_starred: "Starred",
  email_folder_starred: "Starred",
  email_select: "Selectează",
  email_attachment_singular: "Atașament",
  email_attachment_plural: "Atașamente",
  email_back: "Înapoi",
  email_download: "Descarcă",
  email_close: "Închide",
  email_preview: "Previzualizare",
  email_preview_not_available: "Previzualizare indisponibilă",
  email_preview_failed: "Previzualizare indisponibilă",
  select_attachments: "Selectează atașamentele",
  email_loading_preview: "Se încarcă previzualizarea...",
  email_mark_unread_failed: "e-mail(uri) nu au putut fi marcate ca necitite.",
  email_delete_failed: "e-mail(uri) nu au putut fi șterse.",
  filter_all: "Toate",
  filter_email: "E-Mail",
  filter_kjuup_messages: "Kjuup",
  filter_direct_messages: "Mesaje directe",
  my_notes: "My Space",
  filter_internal_groups: "Chaturi de grup interne",
  filter_external_groups: "Chaturi de grup externe",
  filter_group_chats: "Chat-uri de grup",
  filter_groups_internal: "Interne",
  filter_groups_external: "Externe",
  filter_unread_only: "Doar necitite",
  room_daily_briefing_info: "Când este activat, un raport pentru acest proiect este generat la fiecare 24 de ore la ora specificată în setările personale — dar numai dacă a existat activitate în acea perioadă.",
  email_select_all: "Selectează tot",
  email_deselect_all: "Deselectează tot",
  email_reply_all: "Răspunde tuturor",
  email_reply_placeholder: "Tastați răspunsul...",
  email_forward_placeholder: "Adăugați un mesaj...",
  email_edit_draft: "Editare ciornă",
  email_attach: "Atașează",
  email_attachment_from_original: "Din mesajul original",
  email_remove: "Elimină",
  email_drop_files: "Trageți fișierele pentru a le atașa",
  email_loading_attachments: "Se încarcă atașamentele...",
  email_archive: "Arhivează",
  mark_unread: "Marchează ca necitit",
  mark_read: "Marchează ca citit",
  email_all_accounts: "Toate conturile",
  email_error: "Eroare",
  email_delete_email_failed: "Ștergerea e-mailului a eșuat.",
  enter_url: "Introduceți URL",

  // ─── Kjuup subscription ───────────────────────────────────────────
  kjuup_io: 'Kjuup.io',
  kjuup_io_manage_subscription: 'Manage your subscription',
  kjuup_io_subscribe_now: 'Abonează-te acum',
  kjuup_io_hero_subtitle: 'Upgrade to unlock premium features and get more out of every project.',
  kjuup_io_trial_badge: '1 LUNĂ DE PROBĂ GRATUITĂ',
  kjuup_io_trial_title: 'Unlock Kjuup.io Premium',
  kjuup_io_trial_subtitle: 'Connect your email, receive AI-powered smart replies and synchronize your tasks with your calendar.',
  kjuup_io_trial_no_payment: 'No payment today.',
  kjuup_io_trial_trust: 'Nicio plată astăzi. Nu se solicită date de card înainte de începerea abonamentului plătit.',
  kjuup_io_after_trial_monthly: 'After trial: {price}/month',
  kjuup_io_after_trial_yearly: 'After trial: {price}/year',
  kjuup_io_price_per_month: '{price}/month',
  kjuup_io_price_per_year: '{price}/year',
  kjuup_io_start_free_trial: 'Start free now � no risk',
  kjuup_io_trial_footnote: 'No payment today. Then {price}. Cancel anytime.',
  kjuup_io_feature_email: 'Gestionează toate conturile de e-mail direct în Kjuup',
  kjuup_io_feature_assign: 'Automatically assign emails and attachments to projects',
  kjuup_io_feature_ai: 'AI scrie răspunsurile – tu doar confirmi',
  kjuup_io_feature_tasks: 'Sarcini și calendar mereu actualizate automat',
  kjuup_io_choose_plan: 'Alege planul',
  kjuup_io_plan_monthly: 'Lunar',
  kjuup_io_plan_yearly: 'Anual',
  kjuup_io_plan_monthly_desc: 'Billed monthly · cancel anytime',
  kjuup_io_plan_yearly_desc: 'Save {pct}% with annual booking',
  kjuup_io_save_badge: 'SAVE {pct}%',
  kjuup_io_per_month_annual: '{price} / month · Save {pct}% with annual booking',
  kjuup_io_subscribe: 'Subscribe',
  kjuup_io_secured_stripe: 'Securizat prin Stripe · anulare oricând',
  kjuup_io_your_subscription: 'YOUR SUBSCRIPTION',
  kjuup_io_status_active: 'ACTIVE',
  kjuup_io_status_cancels_soon: 'CANCELS SOON',
  kjuup_io_status_switch_scheduled: 'SWITCH SCHEDULED',
  kjuup_io_label_plan: 'Plan',
  kjuup_io_label_price: 'Price',
  kjuup_io_label_status: 'Status',
  kjuup_io_label_renews: 'Renews on',
  kjuup_io_label_access_until: 'Access until',
  kjuup_io_switching_to: 'Switching to {plan} on {date}',
  kjuup_io_cancel_pending_note: 'Your subscription is set to cancel and won\'t renew. You keep access until the date above.',
  kjuup_io_resume: 'Resume subscription',
  kjuup_io_switch_to_plan: 'Switch to {plan} plan',
  kjuup_io_undo_switch: 'Undo scheduled change',
  kjuup_io_cancel_subscription: 'Cancel subscription',
  kjuup_io_switch_modal_title: 'Switch to {plan} plan?',
  kjuup_io_billed_yearly: 'Billed yearly',
  kjuup_io_billed_monthly: 'Billed monthly',
  kjuup_io_switch_modal_note: 'Starts on {date}, when your current {plan} plan ends. No charge today — you keep your current plan until then.',
  kjuup_io_confirm_switch: 'Confirm switch',
  kjuup_io_not_now: 'Not now',
  kjuup_io_cancel_modal_title: 'Cancel subscription?',
  kjuup_io_cancel_modal_note: 'You\'ll keep access to Kjuup.io until the end of your current billing period. After that it won\'t renew.',
  kjuup_io_cancel_modal_note_with_date: 'You\'ll keep access to Kjuup.io until the end of your current billing period ({date}). After that it won\'t renew.',
  kjuup_io_cancel_plan: 'Cancel plan',
  kjuup_io_keep_subscription: 'Keep my subscription',
  kjuup_io_toast_payment_failed: 'Payment failed',
  kjuup_io_toast_activating: 'Plată primită. Abonamentul se activează…',
  kjuup_io_toast_activating_soon: 'Plată primită. Abonamentul dvs. va fi activat în curând.',
  kjuup_io_toast_cancel_period: 'Your subscription will cancel at the end of the period',
  kjuup_io_toast_cancel_fail: 'Unable to cancel subscription',
  kjuup_io_toast_switch_scheduled: 'You\'ll move to the {plan} plan when your current period ends',
  kjuup_io_toast_switch_fail: 'Unable to switch plan',
  kjuup_io_toast_resumed: 'Your subscription will keep renewing',
  kjuup_io_toast_resume_fail: 'Unable to resume subscription',
  kjuup_io_toast_undo: 'Scheduled plan change canceled',
  kjuup_io_toast_undo_fail: 'Unable to cancel the scheduled change',
  kjuup_io_email_locked_body: 'Email is part of Kjuup.io. Activate a plan to use the Email tab.',
  kjuup_io_connect_email: 'Connect email with Kjuup.io',
  kjuup_io_activate_to_connect_email: 'Activate Kjuup.io to connect email accounts',

  kjuup_io_trial_no_card: 'No credit card details are requested before your paid subscription starts.',
  kjuup_io_status_trialing: 'TRIAL',
  kjuup_io_trial_days_left: '{days} days left in your free trial',
  kjuup_io_trial_left_hours: 'Timp rămas: {count} h',
  kjuup_io_trial_left_hour: 'Mai este 1 oră',
  kjuup_io_trial_left_minutes: 'Timp rămas: {count} min',
  kjuup_io_trial_left_minute: 'Mai este 1 minut',
  kjuup_io_trial_left_seconds: 'Timp rămas: {count} s',
  kjuup_io_trial_left_second: 'Mai este 1 secundă',
  kjuup_io_trial_ending_now: 'Perioada de probă se încheie…',
  kjuup_io_request_timeout: 'Conexiunea a expirat. Încercați din nou.',
  kjuup_io_info_days_free: '{days} de zile complet gratuite – abonamentul începe doar după perioada de probă.',
  kjuup_io_discount_total: 'Reducerea ta: {percent}%',
  kjuup_io_discount_company: '{company}: {percent}%',
  kjuup_io_discount_personal: 'Personală: {percent}%',
  kjuup_io_trial_ends_tomorrow: 'Your free trial ends tomorrow',
  kjuup_io_trial_ends_today: 'Your free trial ends today',
  kjuup_io_banner_dismiss: 'Închide',
  kjuup_io_billing_after_trial: 'You\'ll be charged after your trial ends on {date}.',
  kjuup_io_trial_ended_title: 'Perioada de probă gratuită s-a încheiat',
  kjuup_io_trial_ended_body: 'Abonați-vă la Kjuup.io pentru a folosi în continuare e-mailul și alte funcții premium.',
  kjuup_io_subscribe_to_continue: 'Subscribe now to continue',
  kjuup_io_trial_active_title: 'You\'re on a free trial',
  kjuup_io_trial_active_subtitle: 'Choose a plan and subscribe — billing starts when your trial ends.',
  kjuup_io_toast_trial_started: 'Perioada de probă gratuită a început',
  kjuup_io_toast_trial_fail: 'Perioada de probă gratuită nu a putut fi pornită',
  kjuup_io_trial_try_month: 'Try Kjuup.io free for one month.',
  kjuup_io_per_month: 'per month',
  kjuup_io_price_month_line: '{price} / lună',
  kjuup_io_save_amount_year: 'Economisești {price} pe an',
  kjuup_io_billed_annually_amount: '{price} facturat anual',
  kjuup_io_save_yearly: 'Save {pct}% with yearly billing.',
  kjuup_io_savings_pct: '{pct}% savings',
  kjuup_io_features_title: 'Ce primești:',
  kjuup_io_info_one_month_free: 'One month free',
  kjuup_io_info_plan_after_trial: 'Your selected subscription starts after the trial.',
  kjuup_io_info_cancel_trial: 'Cancel anytime during the trial.',
  kjuup_io_info_no_card: 'Nu este necesar cardul – începe imediat, fără date de plată.',
  kjuup_io_info_cancel_anytime: 'Anulează oricând – fără angajament, fără risc.',
  kjuup_io_cta_plan_begins: 'Your selected plan begins after the free trial.',
  kjuup_io_billing_period_aria: 'Perioadă de facturare',
  kjuup_io_subscription_info_title: 'Subscription information',
  kjuup_io_first_payment_on: 'First payment on {date}.',
  kjuup_io_renews_on: 'Renews on {date}.',
  kjuup_io_toast_card_saved: 'Metoda de plată a fost salvată. Plata va fi percepută la finalul perioadei de probă.',
  calendar_sync_info: 'Sincronizează automat toate ToDo-urile Kjuup cu calendarul tău.',
  calendar_no_accounts: 'Niciun calendar conectat încă.',
  article_new_badge: 'NOU',
  article_new_posts: '{0} postări noi',
  documents: 'Documente',
  add_documents: 'Adaugă documente',
  no_preview_available: 'Previzualizare indisponibilă',
  no_preview_hint: 'Acest tip de fișier nu poate fi previzualizat, dar va fi trimis oricum.',
  max_documents_reached: 'Poți atașa până la 10 documente odată.',
  open_file: 'Deschide fișierul',
  twofa_title: 'Autentificare în doi pași',
  twofa_method_totp: 'Aplicație de autentificare',
  twofa_method_sms: 'SMS',
  twofa_method_email: 'E-mail',
  twofa_enter_app: 'Introdu codul din 6 cifre din aplicația de autentificare.',
  twofa_enter_sms: 'Introdu codul din 6 cifre trimis prin SMS.',
  twofa_enter_email: 'Introdu codul din 6 cifre trimis pe e-mail.',
  twofa_resend: 'Retrimite codul',
  twofa_try_another: 'Încearcă altă metodă',
  twofa_remember_device: 'Nu mai întreba pe acest dispozitiv 30 de zile',
  twofa_sent: 'Am trimis un cod.',
  twofa_invalid_code: 'Codul este greșit. Încearcă din nou.',
  twofa_something_wrong: 'A apărut o eroare. Încearcă din nou.',
  twofa_method_unavailable: 'Această metodă nu este disponibilă.',
  twofa_on_desc: 'Autentificarea în doi pași este activă. Vei avea nevoie de un cod la fiecare autentificare.',
  twofa_off_desc: 'Adaugă un al doilea pas după parolă. Aplicațiile de autentificare sunt cea mai sigură opțiune.',
  twofa_methods: 'Metode',
  twofa_on: 'Activat',
  twofa_add: 'Adaugă',
  twofa_default_method: 'Metodă implicită',
  twofa_default: 'Implicit',
  twofa_turn_off: 'Dezactivează',
  twofa_disable_hint: 'Introdu parola și un cod actual pentru a dezactiva autentificarea în doi pași.',
  twofa_disable_need: 'Introdu parola și un cod de verificare.',
  twofa_code_placeholder: 'Cod din 6 cifre sau de rezervă',
  twofa_send_code: 'Trimite un cod',
  twofa_primary_updated: 'Metoda implicită a fost actualizată.',
  twofa_disabled: 'Autentificarea în doi pași este dezactivată.',
  twofa_enabled: 'Autentificarea în doi pași este acum activă.',
  twofa_totp_help: 'Scanează acest QR cu Google Authenticator, Authy sau 1Password. Poți introduce cheia și manual.',
  twofa_secret_copied: 'Cheia a fost copiată',
  twofa_sms_help: 'Introdu numărul în format internațional. Vom trimite un cod din 6 cifre prin SMS.',
  twofa_email_help: 'Vom trimite un cod din 6 cifre la e-mailul contului tău.',
  twofa_backup_title: 'Coduri de rezervă',
  twofa_backup_help: 'Păstrează aceste coduri de unică folosință într-un loc sigur. Fiecare cod se folosește o dată dacă îți pierzi telefonul.',
  twofa_copy_codes: 'Copiază codurile',
  twofa_codes_copied: 'Codurile de rezervă au fost copiate',
  twofa_regenerate: 'Obține coduri de rezervă noi',
  twofa_regenerate_hint: 'Aceasta înlocuiește codurile de rezervă nefolosite. Introdu parola și un cod actual.',
  twofa_backup_remaining: '{n} coduri de rezervă nefolosite rămase',
  twofa_new_codes: 'Coduri de rezervă noi',
  twofa_sms_unavailable: 'Codurile prin SMS nu sunt încă disponibile.',
  todoist_sync_title: "Todoist",
  todoist_sync_info: "Sarcinile Kjuup care ți-au fost atribuite sunt copiate într-un proiect Kjuup din Todoist. Modificările din Todoist nu sunt copiate înapoi.",
  todoist_connect: "Conectează Todoist",
  todoist_connected: "Todoist conectat",
  todoist_connect_failed: "Conectarea la Todoist a eșuat",
  todoist_disconnect: "Deconectează",
  todoist_disconnected: "Todoist deconectat",
  todoist_disconnect_confirm: "Deconectezi Todoist? Sarcinile deja existente în Todoist rămân. Sincronizarea se oprește.",
  todoist_sync_now: "Sincronizează acum",
  todoist_syncing: "Se sincronizează…",
  todoist_sync_done: "Sincronizare finalizată",
  todoist_sync_failed: "Sincronizarea a eșuat",
  todoist_auth_error: "Reconectează Todoist pentru a continua sincronizarea.",
  todoist_last_sync: "Ultima sincronizare",
  todoist_not_connected: "Todoist nu este conectat",
  todoist_auth_url_failed: "Pagina de autorizare Todoist nu a putut fi deschisă.",
  recommend_text: "Alătură-te Kjuup ca să rămâi conectat și să-ți păstrezi comunicarea organizată. Adună-ți canalele la un loc, ține mesajele în proiectele potrivite și începe fiecare dimineață cu un rezumat și sarcinile tale – totul sincronizat cu aplicațiile pe care le folosești deja. Începe gratuit:",
  pro_auth_signin_title: 'Bine ați revenit',
  pro_auth_signin_sub: 'Conectați-vă cu e-mailul de serviciu.',
  pro_auth_email_or_username: 'E-mail sau nume utilizator',
  pro_auth_email_placeholder: 'nume@companie.ro',
  pro_auth_forgot_password: 'Ați uitat parola?',
  pro_auth_create_account: 'Creați cont',
  pro_auth_show_password: 'Afișați parola',
  pro_auth_hide_password: 'Ascundeți parola',
  pro_auth_register_sub: 'Vă vom trimite un link pentru a confirma e-mailul.',
  pro_auth_register_plus_sub: 'Alegeți un nume de utilizator și o parolă. Apoi setați PIN-ul de securitate.',
  pro_auth_check_credentials: 'Verificați e-mailul și parola',
  pro_news_export_pdf: 'Exportați ca PDF',
  pro_news_pdf_failed: 'PDF-ul nu a putut fi creat.',
  pro_news_pdf_attachments: 'Atașamente',
  pro_news_pdf_video: 'Video',
  pro_auth_forgot_sub: 'Introduceți e-mailul și vă vom trimite un link pentru resetarea parolei.',
  pro_auth_send_link: 'Trimiteți link de resetare',
  pro_auth_plus_reset: 'Resetați cu PIN',
  pro_auth_show_pin: 'Afișați PIN-ul',
  pro_auth_hide_pin: 'Ascundeți PIN-ul',
  v2_auth_plus_only: 'Doar Kjuup+',
  room_action_media: "Fișiere",
  room_tab_overview: "Prezentare",
  room_tab_history: "Istoric",
  chat_info_media: "Fișiere",
  messages: "mesaje",
  pro_todo_project_required: "Alege un proiect",
  pro_todo_choose_project: "Pentru ce proiect este această sarcină?",
  cockpit_report_delete_confirm: "Ștergeți acest raport zilnic?",
  cockpit_report_deleted: "Raport zilnic șters",
  cockpit_tab_company: "Companie",
  cockpit_bookmarked_priorities: "Sarcini marcate",
  cockpit_load_error: "Cockpitul nu a putut fi încărcat.",
  cockpit_retry: "Încercați din nou",
  cockpit_yesterday: "Ieri",
  cockpit_greeting_morning: "Bună dimineața",
  cockpit_greeting_day: "Bună ziua",
  cockpit_greeting_evening: "Bună seara",
  cockpit_assistant_q_open: "Ce este deschis astăzi?",
  cockpit_assistant_q_summarize: "Rezumă chatul {{room}}",
  cockpit_assistant_q_overdue: "Care sarcini sunt întârziate?",
  cockpit_assistant_new: "{{n}} noi",
  cockpit_assistant_important: "{{n}} importante",
  cockpit_assistant_title: "Asistent Kjuup",
  cockpit_assistant_hint: "Atingeți și întrebați",
  room_overview_priority_no_detail: "Raportul nu oferă detalii suplimentare despre această prioritate.",
  room_overview_priority_from: "Sursă: {{name}}",
  room_overview_priority_open_task: "Deschide sarcina",
  cockpit_priority_position: "{{index}} din {{total}} priorități",
  room_overview_today_title: "Important azi",
  room_overview_all_tasks: "Toate",
  room_overview_tasks_empty: "Niciun termen sau sarcină deschisă",
  room_overview_appointments_empty: "Nicio programare viitoare",
  room_overview_no_priorities: "Nicio prioritate deschisă în ultimul raport.",
  cockpit_report_top5: "Top 5 priorități",
  cockpit_report_todo_created: "Sarcină creată",
  cockpit_report_source_missing: "Mesajul sursă nu a fost găsit.",
  delete_bookmarked_priority_confirm: "Sigur doriți să ștergeți această sarcină marcată?",
  cockpit_report_create_todo: "Creează sarcină",
  cockpit_priorities_deleting: "Se șterge …",
  cockpit_priorities_select: "Șterge mai multe",
  cockpit_report_none: "Nicio intrare.",
  cockpit_priorities_delete_confirm: "Sigur doriți să ștergeți {count} sarcini marcate?",
  cockpit_priorities_delete_failed: "Nu s-au putut șterge {count} sarcini",
  cockpit_priorities_deleted: "{count} sarcini șterse",
  cockpit_priorities_selected: "{count} selectate",
  cockpit_channel_connected: "Conectat",
  cockpit_channel_not_connected: "Neconectat",
  cockpit_channel_connect: "Conectează",
  cockpit_channel_chat: "Chat Kjuup",
  cockpit_channel_active: "Activ",
  cockpit_channel_hidden: "Ascuns",
  cockpit_channel_enable: "Activează",
  cockpit_channel_email: "E-mail",
  cockpit_channel_check: "Verifică conexiunea",
  cockpit_channel_fix: "Verifică",
  cockpit_channel_forward: "Adresă de redirecționare",
  cockpit_channel_not_set_up: "Neconfigurat",
  cockpit_channel_set_up: "Configurează",
  cockpit_channel_teams: "Microsoft Teams",
  cockpit_channel_broken: "Conexiune întreruptă",
  cockpit_channel_importing: "Import în curs",
  cockpit_channel_removing: "Se deconectează",
  cockpit_channel_reconnect: "Reconectează",
  cockpit_channels_title: "Canale",
  cockpit_company_role_super_admin: "Administrator companie",
  cockpit_company_role_dept_admin: "Administrator departament",
  cockpit_company_role_member: "Angajat",
  cockpit_company_none: "Nu a fost găsită nicio companie Kjuup+",
  cockpit_company_eyebrow: "Companie",
  cockpit_company_inactive: "inactiv",
  cockpit_company_settings: "Setările companiei",
  cockpit_company_employees: "Angajați",
  cockpit_company_internal_rooms: "Proiecte interne",
  cockpit_report_all_projects: "Toate proiectele",
  cockpit_report_progress_emails: "Se analizează e-mailurile",
  cockpit_report_progress_chats: "Se analizează mesajele din chat",
  cockpit_report_progress_documents: "Se analizează atașamentele și documentele",
  cockpit_report_progress_tasks: "Se analizează sarcinile",
  cockpit_report_progress_summarizing: "Se analizează conținutul",
  cockpit_report_progress_reading: "Se reutilizează conținutul deja analizat",
  cockpit_report_progress_collecting: "Se colectează e-mailuri, chaturi și sarcini din proiectele dvs.",
  cockpit_report_progress_priorities: "Se compun prioritățile, termenele limită și deciziile",
  cockpit_report_progress_queued: "Se pregătește raportul",
  cockpit_report_creating_title: "Raportul dvs. zilnic este în curs de pregătire",
  cockpit_report_progress_count_one: "1 element analizat",
  cockpit_report_progress_count_many: "{{count}} elemente analizate",
  cockpit_report_progress_hint: "De obicei durează între unul și două minute – între timp puteți continua să folosiți cockpitul.",
  cockpit_report_time_hint: "Raportul zilnic se creează în fiecare zi la {{hour}}:00 pentru cele cinci proiecte cele mai active.",
  room_overview_priorities_title: "Stare actuală și priorități",
  room_overview_as_of: "Stare la: {{time}}",
  cockpit_report_delete: "Șterge raportul zilnic",
  email_tag_daily_briefing: "Raport zilnic",
  cockpit_report_unread: "Nou",
  cockpit_report_clear_project: "Afișează toate proiectele",
  cockpit_filter_project: "Proiect",
  cockpit_filter_all_projects: "Toate proiectele",
  cockpit_report_recreate: "Recreează raportul zilnic",
  cockpit_report_hide_previous: "Ascunde rapoartele zilnice anterioare",
  cockpit_report_show_previous: "Afișează rapoartele zilnice anterioare",
  cockpit_report_room_empty: "Încă nu există raport zilnic pentru acest proiect",
  cockpit_report_empty: "Încă nu există raport zilnic",
  cockpit_report_room_empty_hint: "Creați un raport zilnic doar pentru acest proiect.",
  cockpit_report_needs_mailbox: "Conectați un cont de e-mail pentru ca Kjuup să poată crea un raport zilnic cu sarcini automate.",
  cockpit_report_create: "Creează raport zilnic",
  cockpit_email_connect: "Conectează e-mailul",
  cockpit_email_none_title: "Încă nu este conectat niciun cont de e-mail",
  cockpit_email_none_reports: "Conectați-vă căsuța poștală pentru ca Kjuup să atribuie e-mailurile primite proiectelor dvs. și să creeze din ele rapoarte zilnice cu sarcini.",
  cockpit_email_none_client: "Conectați Gmail, Outlook sau IMAP pentru a citi, atribui și răspunde la e-mailuri direct în Kjuup.io.",
  cockpit_email_reports_title: "Clientul de e-mail actual",
  cockpit_email_reports_text: "Fără căsuță poștală în Kjuup.io · {{rooms}} proiecte cu raport zilnic la {{hour}}:00 · e-mailurile primite sunt atribuite proiectelor dvs.",
  cockpit_email_reports_rooms: "Gestionează proiectele",
  cockpit_email_settings: "Setări e-mail",
  cockpit_email_error_title: "Verifică conexiunea",
  cockpit_email_client_title: "Recepție configurată",
  cockpit_email_accounts_n: "{{n}} cont conectat",
  cockpit_email_last_sync: "ultima sincronizare {{when}}",
  cockpit_email_report_at: "Raport zilnic la {{hour}}:00",
  cockpit_email_open_inbox: "Deschide căsuța poștală",
  cockpit_email_eyebrow: "Kjuup-Email",
  cockpit_email_accounts_label: "Adrese de e-mail conectate",
  email_folder_sent: "Trimise",
  email_no_subject: "(Fără subiect)",
  cockpit_email_detail_loading: "Se încarcă e-mailul …",
  cockpit_email_detail_failed: "E-mailul nu a putut fi încărcat.",
  cockpit_email_detail_empty: "Acest e-mail nu are text.",
  cockpit_personal_settings: "Setări personale",
  cockpit_companies: "Companii",
  cockpit_title: "Cockpit",
  cockpit_back: "Înapoi la prezentare generală",
  cockpit_day_overview: "Ziua dvs. dintr-o privire",
  email_saved_to_project: "E-mail salvat în proiect",
  email_classify_need_project: "Introduceți un nume de proiect",
  cockpit_email_deleted: "E-mail șters",
  cockpit_email_sent_empty: "Încă nu există e-mailuri trimise.",
  cockpit_email_incoming_empty: "Încă nu există e-mailuri primite.",
  cockpit_email_incoming_title: "E-mailuri",
  cockpit_email_incoming_sub: "Atribuiți e-mailurile primite și trimise proiectelor dvs. Atribuirea o puteți ajusta aici.",
  cockpit_email_incoming_unassigned_n: "{{n}} neatribuite",
  cockpit_email_folder_inbox: "Primite",
  cockpit_email_folder_sent: "Trimise",
  cockpit_email_open: "Deschide e-mailul",
  cockpit_email_incoming_suggested: "Sugestie: {{room}}",
  cockpit_email_incoming_apply: "Aplică",
  cockpit_email_incoming_adjust: "Ajustează atribuirea",
  cockpit_email_incoming_saving: "Se salvează …",
  cockpit_email_incoming_unassigned: "Neatribuit",
  cockpit_email_incoming_show_less: "Afișează mai puține",
  cockpit_email_incoming_show_all: "Afișează toate cele {{n}}",
  cockpit_io_settings: "Setări Kjuup.io",
  cockpit_io_settings_sub: "Plan și locuri, atribuirea angajaților, facturare și facturi.",
  products_coming_soon: "În curând disponibil",
  cockpit_upsell_io_title: "Biroul dvs. care gândește alături de dvs.",
  cockpit_upsell_io_text: "Conectați-vă conturile de e-mail cu Kjuup. E-mailurile, atașamentele și mesajele sunt salvate automat în proiectul potrivit și pot fi stocate opțional pe serverul dvs. În fiecare zi primiți un rezumat al tuturor proiectelor cu punctele esențiale din tot conținutul, iar sarcinile dvs. se sincronizează cu calendarul sau cu aplicația de sarcini.",
  cockpit_upsell_io_soon_title: "Încă nu poate fi rezervat",
  cockpit_upsell_io_soon_text: "Kjuup.io va fi lansat în curând. Solicitați informații acum – vă vom anunța imediat ce puteți rezerva Kjuup.io.",
  cockpit_upsell_io_planned_price: "Preț planificat",
  cockpit_upsell_io_cta_request: "Solicită informații",
  kjuup_plus_abo_per_year: "/ an",
  kjuup_plus_abo_per_month: "/ lună",
  kjuup_plus_abo_status_active: "Activ",
  kjuup_plus_abo_status_requested: "Reziliere solicitată",
  kjuup_plus_abo_status_past_due: "Plată scadentă",
  kjuup_plus_abo_eyebrow: "Kjuup+ · Abonament",
  kjuup_plus_abo_title: "Pachet Kjuup+",
  kjuup_plus_abo_seats_free_one: "Mai este 1 loc liber",
  kjuup_plus_abo_billing: "Mod de plată",
  kjuup_plus_abo_yearly: "Anual",
  kjuup_plus_abo_monthly: "Lunar",
  kjuup_plus_abo_amount: "Sumă",
  kjuup_plus_abo_ends: "Se încheie la",
  kjuup_plus_abo_renews: "Următoarea reînnoire",
  kjuup_plus_abo_next_invoice: "Următoarea factură",
  kjuup_plus_abo_intro: "Preț de lansare",
  kjuup_plus_abo_pending_tier: "De la următoarea reînnoire",
  kjuup_plus_abo_manual: "Kjuup+ este activ pentru compania dvs. pe baza unui acord individual.",
  kjuup_plus_abo_invoices: "Facturi",
  kjuup_plus_abo_invoice_paid: "Plătită",
  kjuup_plus_abo_invoice_view: "Vezi",
  kjuup_plus_abo_invoices_less: "Afișează mai puține",
  kjuup_plus_abo_member_hint: "Facturarea și rezilierea sunt gestionate de administratorii companiei.",
  kjuup_plus_abo_withdraw: "Retrage solicitarea",
  kjuup_plus_abo_cancel_note: "Motiv (opțional)",
  kjuup_plus_abo_cancel_send: "Solicită rezilierea",
  kjuup_plus_abo_cancel: "Reziliază abonamentul",
  cockpit_upsell_plus_f1: "Gestionați activitățile de comunicare ale tuturor angajaților",
  cockpit_upsell_plus_f2: "Informați anumite grupuri de utilizatori din companie",
  cockpit_upsell_plus_f3: "Salvați chaturile interne de grup",
  cockpit_upsell_plus_when_yearly: "la plata anuală",
  cockpit_upsell_plus_size_small: "1–50 de angajați",
  cockpit_upsell_plus_size_large: "51–200 de angajați",
  cockpit_upsell_plus_title: "Kjuup+ pentru companii",
  cockpit_upsell_plus_text: "Gestionați angajații, drepturile de scriere și comunicarea companiei într-un singur loc. Canalele interne rămân la angajații dvs., canalele externe vă conectează cu partenerii de proiect, iar anumite grupuri le informați țintit. Pe lângă Kjuup+, puteți rezerva accese Kjuup.io pentru grupuri de angajați. Kjuup+ și Kjuup.io pot fi combinate.",
  cockpit_upsell_plus_size: "Dimensiunea companiei",
  cockpit_upsell_plus_billing: "Mod de plată",
  cockpit_upsell_plus_per_company: "/ companie · lună, fără TVA",
  cockpit_upsell_plus_onboarding: "Costurile de onboarding/introducere depind de dimensiunea companiei",
  cockpit_upsell_plus_larger: "Prețuri pentru companii mai mari la cerere",
  cockpit_upsell_plus_cta: "Solicitare fără obligații",
  cockpit_kpi_deadlines_tasks: "Termene limită și sarcini",
  cockpit_kpi_appointments: "Programări",
  cockpit_room_admin: "Administrare proiecte și chaturi",
  cockpit_room_admin_sub: "Toate proiectele companiei cu membri, fișiere media și chaturi.",
  pro_todo_not_found: "Această sarcină nu mai este disponibilă.",
  cockpit_chip_overdue: "Întârziat",
  cockpit_chip_today: "Astăzi",
  cockpit_calendar_week: "Săpt. {{week}}",
  cockpit_prev_week: "Săptămâna anterioară",
  cockpit_next_week: "Săptămâna următoare",
  cockpit_chip_requested: "Solicitat",
  cockpit_todo_due: "Termen limită {{when}}",
  cockpit_todo_at: "ora {{time}}",
  cockpit_todo_requested_from: "de la {{name}}",
  cockpit_todo_since: "din {{when}}",
  cockpit_todo_no_date: "Fără dată",
  cockpit_todo_mark_done: "Marchează ca finalizată",
  cockpit_my_tasks_title: "Sarcinile mele",
  cockpit_today_tasks_group: "Sarcinile de azi",
  cockpit_assign_none: "Nimeni nu este atribuit",
  no_project_found: "Niciun proiect găsit",
  cockpit_row_more_actions: "Mai multe acțiuni",
  needs_date: "Atribuie programare",
  cockpit_assign_proposal: "{{name}} recunoscut – atribuiți?",
  cockpit_assign_proposal_confirm: "Atribuie",
  cockpit_assign_proposal_dismiss: "Ignoră",
  cockpit_priority_date: "Dată",
  todo_calendar_add: "Adaugă în calendar",
  todo_calendar_remove: "Elimină din calendar",
  cockpit_todo_change_project: "Schimbă proiectul",
  cockpit_todo_set_date: "Setează data",
  pro_todo_done_confirm: "Sigur doriți să marcați această sarcină ca finalizată?",
  cockpit_task_delete_failed: "Sarcina nu a putut fi ștearsă.",
  cockpit_setup_title: "Finalizați configurarea",
  cockpit_setup_text: "Decideți dacă doriți să folosiți chaturi și dacă Kjuup.io să funcționeze ca client de e-mail sau doar cu proiecte și rapoarte zilnice.",
  cockpit_setup_cta: "Configurează acum",
  cockpit_group_tasks: "Termene limită și sarcini",
  cockpit_group_appointments: "Programări",
  cockpit_report_no_activity: "În acest proiect nu au existat mesaje sau e-mailuri noi în ultimele 24 de ore.",
  cockpit_report_room_unavailable: "Acest proiect nu este disponibil.",
  cockpit_report_create_failed: "Raportul zilnic nu a putut fi creat.",
  cockpit_report_created: "Raport zilnic creat",
  addon_enable_confirm: "Activați suplimentul?",
  addon_enable: "Activează",
  addon_enabled: "Supliment activat",
  nav_email: "E-mail",
  nav_my_cockpit: "Cockpitul meu",
  nav_news: "Noutăți",
  nav_recommend: "Recomandă",
  pro_todo_status_done: "Finalizat",
  pro_todo_status_open: "Deschis",
  v2_todo_remove: "Elimină",
  pro_todo_search_people: "Caută persoane",
  pro_todo_clear: "Resetează",
  pro_todo_assigned: "(atribuit)",
  pro_todo_no_people: "Nicio persoană găsită",
  pro_todo_search_rooms: "Caută proiecte",
  pro_todo_no_rooms_match: "Niciun proiect nu corespunde cu „{{q}}”",
  pro_todo_no_rooms: "Niciun proiect găsit",
  pro_todo_activity: "Activitate",
  pro_todo_show_less: "Afișează mai puține",
  pro_todo_show_all: "Afișează toate ({{n}})",
  pro_todo_due: "Scadent",
  pro_todo_room: "Proiect",
  pro_todo_select_room: "Selectează proiectul",
  pro_todo_status: "Stare",
  pro_todo_more: "Mai multe",
  pro_todo_edit_title: "Editează sarcina",
  pro_todo_description: "Descriere",
  pro_todo_created_by: "Creat de",
  pro_todo_chat: "Chat",
  navigate_to_source: "Mergi la sursă",
  todo_calendar_connect_title: "Niciun calendar conectat",
  todo_calendar_connect_body_web: "Conectați un calendar în setările de sincronizare a calendarului pentru a-i adăuga sarcini.",
  todo_calendar_connect: "Conectează",
  todo_calendar_removed: "Eliminat din calendarul dvs.",
  todo_calendar_added_later: "Adăugat. Calendarul nu a putut fi accesat; Kjuup va încerca din nou mai târziu.",
  todo_calendar_added: "Adăugat în calendarul dvs.",
  todo_calendar_no_date: "Doar o sarcină cu dată poate fi adăugată într-un calendar.",
  todo_calendar_failed: "Calendarul nu a putut fi actualizat. Încercați din nou.",
  todo_calendar_date_title: "Încă fără dată",
  todo_calendar_date_save: "Setează data și adaugă",
  todo_calendar_date_body_web: "Această sarcină marcată nu are încă o dată. Setați una pentru a o adăuga în calendar.",
  kjuup_io_setup_saved: "Configurare salvată",
  kjuup_io_setup_step: "Pasul",
  kjuup_io_setup_chats_title: "Doriți să folosiți chaturi?",
  kjuup_io_setup_email_title: "Unde doriți să citiți e-mailurile?",
  kjuup_io_setup_chats_sub: "Chaturile cu colegii și partenerii de proiect sunt opționale. Le puteți afișa sau ascunde oricând în cockpit.",
  kjuup_io_setup_email_sub: "Aici alegeți doar dacă folosiți un client de e-mail în Kjuup sau continuați cu programul actual, de exemplu Outlook sau altul. Puteți schimba mai târziu.",
  kjuup_io_setup_chats_yes: "Da, afișează chaturile",
  kjuup_io_setup_chats_yes_text: "Mesajele conțin chaturi și e-mailuri. Proiectele au chaturi de grup pentru toți participanții.",
  kjuup_io_setup_chats_no: "Nu, lucrez fără chaturi",
  kjuup_io_setup_chats_no_text: "Chaturile sunt ascunse. „Mesaje” devine „E-mail”; proiectele, sarcinile și rapoartele zilnice rămân.",
  kjuup_io_setup_email_client: "Client de e-mail în Kjuup",
  kjuup_io_setup_email_client_text: "Citiți și răspundeți la e-mailuri direct în Kjuup.",
  kjuup_io_setup_email_reports: "Clientul de e-mail actual",
  kjuup_io_setup_email_reports_text: "Continuați să citiți și să răspundeți la e-mailuri în programul actual, de exemplu Outlook sau altul.",
  kjuup_io_setup_skip: "Mai târziu",
  next: "Înainte",
  kjuup_io_setup_finish: "Finalizează configurarea",
  today_label: "astăzi",
  tomorrow_label: "mâine",
  cockpit_todo_overdue: "întârziat",
  cockpit_report_management_fazit: "Concluzie pentru management",
  cockpit_todo_appointment: "Programare",
  cockpit_todo_deadline: "Termen limită",
  cockpit_todo_deadline_define: "Definește termenul limită",
  pro_todo_status_acknowledged: "Confirmat",
  pro_todo_responsible: "Responsabil",
  pro_todo_notice_confirmed: "Confirmat în chat",
  pro_todo_notice_sent_at: "Mesaj trimis",
  pro_todo_notice_again: "Trimite din nou mesajul",
  pro_todo_notice_send: "Informează prin mesaj Kjuup",
  pro_todo_add_assignee: "Adaugă",
  pro_todo_edit: "Editează",
  pro_todo_change_room: "Schimbă proiectul",
  pro_todo_due_on: "Scadent la",
  pro_todo_edit_due: "Editează scadența",
  pro_todo_no_date: "Fără dată",
  pro_todo_edit_description: "Editează descrierea",
  pro_todo_no_description: "Încă fără descriere",
  pro_todo_title_label: "Titlu",
  pro_todo_title_placeholder: "Introduceți titlul...",
  pro_todo_task: "Sarcină",
  pro_todo_what: "Ce trebuie făcut?",
  pro_todo_source_email: "E-mail",
  pro_todo_sources: "Surse",
  previous: "Anterior",
  kjuup_plus_abo_tier_large: "Kjuup+ Large (până la {max} angajați)",
  kjuup_plus_abo_tier_small: "Kjuup+ Small (până la {max} angajați)",
  kjuup_plus_abo_status_ends: "Se încheie pe {date}",
  kjuup_plus_abo_seats_over: "Peste {max} angajați – Kjuup vă va contacta cu o ofertă personalizată.",
  kjuup_plus_abo_seats_next: "Dacă se alătură mai mulți angajați, pachetul trece automat la {next} (calculat proporțional).",
  kjuup_plus_abo_seats_used: "{used} din {total} locuri ocupate",
  kjuup_plus_abo_seats_free: "Mai sunt {count} locuri libere",
  kjuup_plus_abo_intro_until: "până la {date}",
  kjuup_plus_abo_invoice_open: "Neachitată · scadentă pe {date}",
  kjuup_plus_abo_invoices_all: "Afișează toate ({count})",
  kjuup_plus_abo_requested_hint: "Reziliere solicitată pe {date}. Kjuup o confirmă la sfârșitul perioadei contractuale ({end}).",
  kjuup_plus_abo_cancel_hint: "Kjuup analizează solicitarea dvs. și confirmă rezilierea la sfârșitul perioadei contractuale ({end}). Până atunci, Kjuup+ rămâne activ.",
  kjuup_plus_abo_withdrawn: "Solicitarea de reziliere a fost retrasă",
  kjuup_plus_abo_requested: "Reziliere solicitată",
  cockpit_upsell_plus_intro_hint: "primele {months} luni, apoi {price}",
  cockpit_upsell_plus_badge: "PREȚ DE LANSARE PENTRU {months} LUNI",
  calendar_syncing: "Se actualizează din calendar…",
  calendar_sync_up_to_date: "Calendarul este la zi",
  calendar_sync_failed: "Sincronizarea a eșuat",
  delete_multiple_tasks_confirm: "Sigur doriți să ștergeți {count} ToDo-uri?",
  todos_deleted_count: "{count} ToDo-uri șterse",
  todos_deleted_partial: "{ok} ToDo-uri șterse, {fail} eșuate",
  todo_unknown: "Necunoscut",
  todo_created_from_message: "Sarcină creată din acest mesaj",
  kjuup_io_todo_calendar_trial_ended_note: "Sincronizare calendar · Abonați-vă",
  kjuup_io_todo_calendar_nudge: "Sincronizați acest ToDo cu calendarul dvs.?",
  kjuup_io_todo_calendar_nudge_cta: "Activați Kjuup.io",
  todo_confirmed: "ToDo confirmat",
  pro_todo_bulk_delete_title: "Ștergeți {{n}} sarcini?",
  pro_todo_previous_none_own: "Sarcinile întârziate v-au fost atribuite de alții și pot fi șterse doar de aceștia.",
  pro_todo_previous_none: "Nicio sarcină întârziată",
  pro_todo_previous_title: "Ștergeți {{n}} sarcini întârziate?",
  pro_todo_previous_text: "Toate sarcinile dvs. deschise din zilele anterioare vor fi șterse.",
  pro_todo_previous_skipped: "{{n}} atribuite de alții rămân.",
  unassign_task_confirm: "Doriți să vă anulați atribuirea la această sarcină?",
  unassign_label: "Anulați",
  pro_todo_delete_title: "Șterge sarcina",
  pro_todo_today: "Astăzi",
  pro_todo_yesterday: "Ieri",
  pro_todo_since_yesterday: "De ieri",
  pro_todo_mark_open: "Marchează ca deschisă",
  verify_completion: "Verificați",
  new_label: "Nou",
  bookmarked_no_mylist: "Sarcinile marcate nu pot fi adăugate în Lista mea",
  delete_only_own: "Puteți șterge doar sarcinile create de dvs.",
  todo_clear_all: "Șterge tot",
  pro_todo_of_completed: "{{done}} din {{total}} finalizate",
  pro_todo_pick_date: "Alegeți o dată",
  pro_todo_show_day: "Afișați ziua",
  todo_adjust_list: "Ajustează lista",
  pro_todo_section_upcoming: "Viitoare",
  pro_todo_section_done: "Finalizate",
  pro_todo_room_empty_today: "Nicio sarcină astăzi în acest proiect",
  pro_todo_room_empty_day: "Nicio sarcină în această zi în acest proiect",
  pro_todo_delete_previous: "Șterge toate",
  todo_my_list_empty: "Ziua ta este goală",
  todo_my_list_empty_hint: "Faceți clic pe „Ajustează lista” pentru a adăuga sarcini",
  pro_todo_empty_title: "Nimic aici",
  pro_todo_empty_hint: "Nicio sarcină nu corespunde acestei vizualizări.",
  pro_todo_selected: "{{n}} selectate",
  delete_selected_count: "Șterge ({count})",
  pro_todo_adjust_done: "Gata",
  pro_todo_deleting: "Se șterge...",
  pro_todo_reopen: "Redeschideți sarcina",
  pro_todo_step_done: "Finalizat",
  move_back_in_progress: "Mută înapoi în desfășurare",
  pro_todo_mark_not_started: "Marcați ca neînceput",
  back_into_in_progress: "Înapoi la În progres",
  pro_todo_mark_in_progress: "Marcați ca în curs",
  unassign_todo: "Anulați atribuirea ToDo",
  pro_todo_open_room: "Deschideți proiectul",
  pro_todo_new_task: "Sarcină nouă",
  select_user_back_to_in_progress: "Selectați utilizatorul care revine în desfășurare",
  cockpit_email_accounts_n_many: "{{n}} conturi conectate",
  // Kjuup + Microsoft Teams chats (new-chat pickers, combined groups)
  combined_tab_kjuup: "Contacte Kjuup",
  combined_tab_teams: "Contacte Teams",
  combined_bridge_failed: "Copia Teams nu a putut fi creată.",
  combined_chat_label: "Kjuup + Teams",
  combined_guest_tag: "Teams",
  combined_new_group_note: "Contacte Kjuup și Teams: se creează un grup nou, care apare și în Microsoft Teams.",
  teams_new_chat_title: "Chat Teams nou",
  teams_new_chat_topic: "Numele grupului (opțional)",
  teams_new_chat_start: "Pornește chatul",
  teams_new_chat_creating: "Se creează chatul…",
  teams_new_chat_forbidden: "Microsoft Teams nu permite acest chat (de ex. o persoană din afara organizației tale sau o regulă a departamentului IT).",
  teams_new_chat_too_many: "Prea multe persoane pentru un chat.",
  teams_new_chat_type_hint: "Tastează un nume pentru a căuta în organizația ta.",
  teams_new_chat_directory_forbidden: "Organizația ta nu permite căutarea în director. Sunt afișate doar persoanele din chaturile tale Teams.",
  teams_new_chat_account: "Cont",
};
